<template>
  <div>
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showToolbar="true"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <template slot="customer-button">
          <dropdown
            buttonText="查看"
            trigger="click"
            ref="dropdownRef"
            :dropdownItem="dropdownItem"
            @change="handleDropdownChange"
          ></dropdown>
        </template>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // 业务订单列表
  import { mapState } from 'vuex';
  import BASE_API from '@/api/dataBase.js';
  import COM_API from '@/api/masterData/company.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import dropdown from '@/components/dropdown';
  import API from '@/api/purchaseSalesCenter/businessOrder.js';
  import { filterEmpty, toLine } from '@/common/js/util';
  import { mapEnumList } from '@/common/js/enums';
  import { priceObj, columns } from './data';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    name: 'businessOrderList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      SiruiTable,
      dropdown,
    },
    data() {
      return {
        load: false,
        tableData: [],
        menuButtonList: [], // 表格功能按钮
        query: {},
        contractDetailCategory: [],
        columnList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      dropdownItem() {
        return [
          { value: 1, label: '采购数量大于销售数量' },
          { value: 2, label: '采购数量小于等于销售数量' },
          { value: 3, label: '近一个月创建的业务订单' },
          { value: '', label: '清空' },
        ];
      },
      // 搜索栏配置数据
      searchColumns() {
        return [
          {
            type: 'input',
            prop: 'orderNo',
            name: this.$t('businessOrder.list.orderNo'),
          },
          {
            type: 'input',
            prop: 'purchaseContractNo',
            name: this.$t('businessOrder.list.purchaseNo'),
          },
          {
            type: 'input',
            prop: 'salesContractNo',
            name: this.$t('businessOrder.list.salesNo'),
          },
          // sxp 添加 TAPD ID1001223
          {
            // 供应链主体
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.supplierName'),
            prop: 'supplierName',
            searchType: 'supplychain',
            isMultiple: true,
          },
          // =======================
          {
            type: 'select',
            prop: 'contractDetailCategory',
            name: this.$t('businessOrder.list.contractType'),
            clearable: true,
            options: this.contractDetailCategory,
          },
          {
            // 供应商
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.partnerNo'),
            prop: 'contractSupplierName',
            searchType: 'supplier',
            isMultiple: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.customer'),
            prop: 'contractCustomerName',
            searchType: 'customer',
            isMultiple: true,
          },
          {
            type: 'ajaxSelect',
            prop: 'tradeType',
            name: this.$t('businessOrder.list.tradeType'),
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'purchase-trade-type' },
          },
          {
            type: 'ajaxSelect',
            prop: 'businessType',
            name: this.$t('businessOrder.list.businessType'),
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'purchase_business_type' },
          },
          {
            type: 'input',
            prop: 'externalContractNo',
            name: this.$t('businessOrder.list.externalContractNo'),
          },
          {
            type: 'treeSelect', // 业务部门查询的数据
            prop: 'contractBusinessDepartment',
            name: this.$t('businessOrder.list.businessDepartment'),
            apiUrl: COM_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
            },
            clearable: true,
          },
          {
            type: 'startDaterangePicker',
            prop: 'dateStart',
            name: this.$t('businessOrder.search.dateStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'dateEnd',
            name: this.$t('businessOrder.search.dateEnd'),
          },
          {
            type: 'inputRange',
            prop: ['quantityStart', 'quantityEnd'],
            name: this.$t('businessOrder.list.contractNumberSearch'),
            precision: this.$globalVar.qPoint, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.storageNo'),
            prop: 'storageNo',
            searchType: 'warehouse',
            isMultiple: true,
          },
          {
            type: 'select',
            prop: 'priceIdentity',
            name: this.$t('businessOrder.list.priceIdentify'),
            options: mapEnumList(priceObj),
            clearable: true,
          },
          {
            type: 'input',
            prop: 'settleBatchNumber',
            name: this.$t('businessOrder.list.salesBatch'),
          },
          {
            type: 'inputRange',
            prop: ['priceStart', 'priceEnd'],
            name: this.$t('businessOrder.list.contractPriceSearch'),
            precision: 2, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.productNo'),
            prop: 'productDesc',
            searchType: 'goodsDetail',
            isMultiple: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.salesMan'),
            prop: 'contractSalesmanNo',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('businessOrder.list.operateMan'),
            prop: 'contractOperaterNo',
            searchType: 'personnel',
            isMultiple: true,
          },
        ];
      },
    },
    mounted() {
      this.initQuery();
      this.getData();
      this.geContractType('purchase_contract_detail_category');
      this.geContractType('sales_contract_detail_category');
      this.$nextTick(() => {
        this.getButtonList();
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(columns).then((res) => {
          this.columnList = res;
        });
      },
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query);
      },
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          supplierNo: query.supplierName ? query.supplierName[0].supplierCode : '',
          // contractSupplierName: query.contractSupplierName ? query.contractSupplierName[0].partnerZhName: '',
          // contractCustomerName: query.contractCustomerName ? query.contractCustomerName[0].partnerZhName : '',
          storageNo: query.storageNo ? query.storageNo[0].storageCode : '',
          // productDesc: query.productDesc ? query.productDesc[0].detailProductDisplayName : '',
          contractSalesmanNo: query.contractSalesmanNo ? query.contractSalesmanNo[0].id : '',
          contractOperaterNo: query.contractOperaterNo ? query.contractOperaterNo[0].id : '',
          productNo: this.handleData(query.productDesc, 'productDetailCode'), //商品描述
          contractCustomerNo: this.handleData(query.contractCustomerName, 'partnerCode'), //客户
          contractSupplierNo: this.handleData(query.contractSupplierName, 'partnerCode'), //供应商
          // supplierNo:this.handleData(query.supplierName, "supplierCode"),// 供应链主体
        });
        delete result.contractSupplierName;
        delete result.contractCustomerName;
        delete result.supplierName;
        delete result.productDesc;
        return filterEmpty(result);
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item.partnerCode);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item.productDetailCode);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      handlePath(type, orderNo) {
        let path, name, title;
        if (type == 'add') {
          path = '/businessOrder/add';
          name = 'businessOrderAdd';
          title = this.$t('businessOrder.list.createBtn');
        } else {
          path = '/businessOrder/detail';
          name = 'businessOrderDetail';
          title = this.$t('businessOrder.list.detail');
        }
        let pathRoute = {
          path: path,
          name: name,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: orderNo ? { orderNo } : {},
        };
        this.$store.dispatch('tagsView/addTabView', pathRoute).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathRoute);
          });
        });
      },
      chooseClick(type) {
        if (type == 'add') {
          this.handlePath('add');
        }
        if (type == 'export') {
          this.handleExport();
        }
      },
      getData(search) {
        const params = this.getQuery();
        if (search && Object.keys(params).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        this.load = true;
        // 获取数据
        this.$axios
          .post(API.LIST_ORDER, params)
          .then((res) => {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data.list;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            } else {
              this.tableData = [];
              this.$alert(res.data.msg);
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      geContractType(dictType) {
        this.$axios.post(BASE_API.DIC_CREDIT_API, { dictType }).then((res) => {
          if (res.data.code == 0) {
            this.contractDetailCategory = this.contractDetailCategory.concat(res.data.data);
          }
        });
      },
      handleExport() {
        const params = this.getQuery();
        const tableColumn = this.$refs.siruiTable.getTableColumn();
        const showColumns = [];
        tableColumn.visibleColumn.forEach((item) => {
          if (item.property) {
            showColumns.push({ prop: item.property, label: item.title });
          }
        });
        // 没有选择列
        if (tableColumn < 1) {
          let message = this.$t('contractAgency.errorTips.columnEmptyTip');
          this.$message({ showClose: true, message, type: 'error' });
          return;
        }
        // 导出字段
        params.columns = JSON.stringify(showColumns);
        this.$axios.post(API.EXPORT_ORDER, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 下拉选项改变
      handleDropdownChange(command) {
        this.query.quantityCount = command;
        this.getData();
      },
      // 表格排序
      sortChangeEvent({ property, order }) {
        let orderByDesc = '';
        if (order) {
          orderByDesc = `a.${toLine(property)} ${order}`;
        }
        const query = Object.assign({}, this.query, {
          orderByDesc,
        });
        this.query = query;
        this.getData();
      },
      // 列表双击
      dblclickEvent(value) {
        const row = value.row;
        this.handlePath('detail', row.orderNo);
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.dropdownRef.activeCommand = '';
        this.query.quantityCount = '';
        this.getData();
      },
    },
  };
</script>
